import { extendTheme } from '@chakra-ui/react';

import { colors } from './colors';
import { WhiteText } from './Components/text';
import { config } from './config';
import { fonts } from './fonts';

const customTheme = extendTheme({
  components: {
    Text: WhiteText,
    Heading: WhiteText,
  },
  fonts,
  colors,
  config,
  styles: {
    global: () => ({
      body: {
        bg: 'black',
        color: '#FFFFFF',
      },
      html: {
        bg: 'black',
        color: '#FFFFFF',
      },
    }),
  },
});

export default customTheme;
